import React, { useCallback, useState, useImperativeHandle, forwardRef } from 'react'

import { queryChangeGoods } from '@/services/distributeOrder'

import Query from '../Query'
import Table from '../Table'
import { queryTable } from '@/services/erpStyleImport'

export default forwardRef(
    ({ modalType, selected, setSelected, selectedRows, setSelectedRows, textArea, ...restProps }, ref) => {
        const [query, setQuery] = useState({})

        const fetch = useCallback(
            params => {
                if (modalType === 'goods') {
                    return queryChangeGoods({
                        itemCodesVague: '0',
                        styleCodesVague: '0',
                        shortNameVague: '0',
                        propertiesValueVague: '0',
                        ...query,
                        ...params
                    })
                }
                if (modalType === 'style') {
                    return queryTable({
                        itemCodeVague: '0',
                        styleCodeVague: '0',
                        ...query,
                        ...params
                    })
                }
            },
            [query]
        )
        useImperativeHandle(
            ref,
            () => ({
                selected,
                selectedRows
            }),
            [selected, selectedRows]
        )

        return (
            <div>
                <Query value={{}} onChange={value => setQuery(value)} modalType={modalType} />
                {textArea}
                <Table
                    fetch={fetch}
                    query={query}
                    modalType={modalType}
                    rowKey={modalType === 'goods' ? 'itemCode' : 'styleCode'}
                    selected={selected}
                    setSelected={setSelected}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                />
            </div>
        )
    }
)
